

function InitializeHoverLists() {

  const hoverBar = document.querySelector('.hover-bar');
  
  if( hoverBar ) {
    
    const container = hoverBar.parentElement;
    const effectEls = document.querySelectorAll(".layout-list");
    
    effectEls.forEach( li => {
      const activeEvents = ["mouseenter", "focus"];

      //On Hover/Focus
      activeEvents.forEach( event => {

        const activateHandler = (e) => {
          //is the current above or below the last?
          if( e.target === e.currentTarget ) {
            hoverBar.style.setProperty('--position', e.currentTarget.offsetTop + 'px');
            hoverBar.style.setProperty('--height', (e.currentTarget.offsetHeight - 2) + 'px');
            hoverBar.style.setProperty('opacity', 1);
          }
        }

        li.removeEventListener(event, activateHandler);
        li.addEventListener(event, activateHandler);
      });

    });

    const deactiveEvents = ["mouseleave", "blur"];

      deactiveEvents.forEach( event => {

        const deactivateHandler = (e) => {
          hoverBar.style.setProperty('--height', 0 + 'px');
          hoverBar.style.setProperty('opacity', 0);
        };

        container.removeEventListener(event, deactivateHandler);
        container.addEventListener(event, deactivateHandler);
      });

  }
  
  // const movingUp = () => {
  //   document.documentElement.style.setProperty("--hl-animation-in", "hover-up");
  //   document.documentElement.style.setProperty("--hl-animation-out", "unhover-fade-up");
  // }

  // const movingDown = () => {
  //   document.documentElement.style.setProperty("--hl-animation-in", "hover-down");
  //   document.documentElement.style.setProperty("--hl-animation-out", "unhover-fade-down");
  // }
  

  //   const effectEls = document.querySelectorAll(".layout-list");

  //   effectEls.forEach((li) => {
  //     const activeEvents = ["mouseenter", "focus"];
  //     const deactiveEvents = ["mouseleave", "blur"];

  //     //On Hover/Focus
  //     activeEvents.forEach( event => {

  //       const activateHandler = (e) => {
  //         //is the current above or below the last?
  //         if( e.target === e.currentTarget ) {
  //           if( e.currentTarget === window.lastHovered ) {
  //             ( e.offsetY < (e.currentTarget.offsetHeight * .5) ) ? movingDown() : movingUp();
  //           } else {
  //             (e.currentTarget.offsetTop > window.lastHovered?.offsetTop) ? movingDown() : movingUp();
  //           }
  //           window.lastHovered = e.currentTarget;
  //         }
  //       }

  //       li.removeEventListener(event, activateHandler);
  //       li.addEventListener(event, activateHandler);
  //     })  

  //     //On MouseOut/Blur
  //     deactiveEvents.forEach( event => {

  //       const deactivateHandler = (e) => {
  //           effectEls.forEach((li) => li.classList.remove("last"));
  //           e.currentTarget.classList.add("last");
  //       };

  //       li.removeEventListener(event, deactivateHandler);
  //       li.addEventListener(event, deactivateHandler);
  //     });
      
  //   });
  }

export {
  InitializeHoverLists
}